$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

$(function() {

    $('#mysearch').hide();

    $('#search-icon, .search-icon').click(function() {
        $('#mysearch').show();
        $('#search-icon').hide();
        $('.overlay').show();
        $('#mysearch').val('');
        $('.nav-container').hide();
        $('#mysearch').focus();
        $('.search-menu').hide();

    });

    $('#mysearch').focusout(function() {
        setTimeout(function(){
            $('#mysearch').val('');
            $('#mysearch').hide();
            $('.overlay').hide();
            $('.nav-container').show();
            $('#search-icon').show();
            $('.search-menu').hide();
        }, 250);
    });

    let timeoutId;
    function doSearch(searchText) {

        let results = '';

        if (searchText.length>0) {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(function () {
                $.ajax({
                    type: "POST",
                    url: '/api/search',
                    data: {search: searchText},
                    success: function (result) {

                        if (result.found.length > 0) {
                            for (let i = 0; i < result.found.length && i < 3; i++) {
                                results += '<li>';
                                results += '<a href="/' + result.found[i].full_slug + '">';
                                results += '<img class="searchimg" src="' + result.found[i].image + '" />';
                                results += '<span>' + result.found[i].name + '</span>';
                                results += '<div class="menuright"><img src="/img/icons/arrow-right-search.svg" alt="search"></div>';
                                results += '</a>';
                                results += '</li>';
                            }
                        } else {
                            results += '<li>';
                            results += '<span class="notfound">Keine Ergebnisse gefunden</span>';
                            results += '</li>';
                        }
                        $('ul.search-menu').html(results);

                        if ($('#mysearch').val().length > 0) {
                            $('.search-menu').show();
                        } else {
                            $('.search-menu').hide();
                        }
                    },
                    error: function (result) {
                        console.error(result);
                    }
                });
            }, 300);
        }
    }


    $('#mysearch').keyup(function() {
        doSearch($(this).val());
    });

    $('#mysearch').change(function() {
        $(this).keyup();
    });

});
